var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "13.86 13.86 72.28 72.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,86.14A36.14,36.14,0,1,0,13.86,50,36.18,36.18,0,0,0,50,86.14Zm0-68.29A32.14,32.14,0,1,1,17.86,50,32.18,32.18,0,0,1,50,17.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.33,53.92a2,2,0,0,0,2,2h3A16.65,16.65,0,0,0,51.94,66.67c5.86,0,9.43-2.78,12.16-5.5a2,2,0,0,0,0-2.81,2.08,2.08,0,0,0-1.41-.56,2,2,0,0,0-1.39.59c-2.74,2.74-5.15,4.33-9.33,4.33A12.62,12.62,0,0,1,40.67,55.9H52.89a2,2,0,0,0,0-4H39.35A13.19,13.19,0,0,1,39.21,50c0-.31,0-.63,0-1H52.89a2,2,0,0,0,0-4H40.21a12.82,12.82,0,0,1,11.73-7.79c4.21,0,6.61,1.58,9.32,4.29a2,2,0,0,0,1.4.6,2,2,0,0,0,1.41-.57,2,2,0,0,0,0-2.81c-2.7-2.7-6.26-5.46-12.15-5.46h0A16.69,16.69,0,0,0,36,45.08h-2.7a2,2,0,0,0,0,4h2c0,.31,0,.63,0,1a16.85,16.85,0,0,0,.11,1.94h-2A2,2,0,0,0,31.33,53.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuro);
export default __webpack_public_path__ + "static/media/icon-euro.6856a3c31d2320435b6b4a3ba3048d3c.svg";
export { ForwardRef as ReactComponent };